export default "__VITE_ASSET__CAxJj7Db__"